import { GetServerSideProps } from 'next';

import { DataType } from '@/core/interfaces/common';

import { api } from '@/features/Articles/api';
import { Article as ArticleType } from '@/features/Articles/Articles.types';
import { Article } from '@/features/Article';

import { withNavigationData } from '@/utils/withNavigationData';

type PageProps = {
  config: {
    articleData: DataType<ArticleType>;
  };
};

const Page = ({ config }: PageProps) => (
  <Article articleData={config?.articleData} />
);

export const getServerSideProps: GetServerSideProps = withNavigationData(async context => {
  const {
    query,
    locale,
  } = context;

  const slug = query.slug as string;
  let config;

  try {
    const articleData = await api.getArticle({
      locale,
      slug,
    });
    const article = articleData.data.data[0];

    if (article) {
      config = {
        articleData: articleData.data.data[0],
      };
    } else {
      return {
        notFound: true,
      };
    }
  } catch (error) {
    return {
      redirect: {
        destination: `/${locale}/404`,
        permanent: true,
      },
    };
  }

  return {
    props: {
      config,
    },
  };
});
export default Page;
